import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import ProductsView from '../views/ProductsView.vue'
import AiChatView from '../views/AiChatView.vue'
import ContactView from '../views/ContactView.vue'
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue'
import TermsView from '../views/TermsView.vue'
import DisclaimerView from '../views/DisclaimerView.vue'

// 默认 SEO（与 index.html 一致，用于首页及未配置 meta 的路由）
const DEFAULT_TITLE = '关键包装 KPP｜食品与餐饮包材定制・纸杯纸袋纸盒印刷'
const DEFAULT_DESCRIPTION = '关键包装 KPP 提供食品与餐饮包材定制服务，包含纸杯、纸袋、纸盒与外带包装，支持设计、印刷、打样与生产落地。'

// 使用直接导入替代懒加载，以便更容易调试
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: DEFAULT_TITLE,
      description: DEFAULT_DESCRIPTION
    }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: {
      title: '关于关键包装 KPP | 食品与餐饮行业包材定制团队',
      description: '了解关键包装（KPP）的品牌理念、服务方向与企业文化。我们专注食品与餐饮行业包材定制，提供更贴近品牌需求的包装解决方案，帮助客户兼顾实用性、视觉表现与品牌价值。'
    }
  },
  {
    path: '/products',
    name: 'products',
    component: ProductsView,
    meta: {
      title: '产品展示 | 关键包装 KPP 包材定制案例与餐饮包装应用',
      description: '查看关键包装（KPP）包材定制案例，涵盖餐饮外带、饮品、烘焙等不同场景，展示纸袋、纸盒、纸杯、吸管包装等在品牌识别、使用体验与视觉呈现上的应用方式。'
    }
  },
  {
    path: '/ai-chat',
    name: 'ai-chat',
    component: AiChatView,
    meta: {
      title: 'AI 开店助手 | 关键包装 KPP 包材咨询与开店包装建议',
      description: '通过关键包装（KPP）AI 开店助手，快速咨询包材定制、材质选择、包装搭配与开店初期包装规划问题，帮助餐饮与食品品牌更有效率地整理需求与方向。'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: {
      title: '联系我们 | 关键包装 KPP 食品与餐饮包材定制咨询',
      description: '联系关键包装（KPP），咨询食品与餐饮行业包材定制需求。无论是新品开发、门店开业、包装升级或日常补货，我们都希望为您提供更合适的包装方案与服务支持。'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPolicyView
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: DisclaimerView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    console.log('滚动行为触发, 目标:', to);
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    } else {
      return { top: 0 }
    }
  }
})

// 根据路由 meta 统一更新 document.title 与 meta description（不引入新库，集中管理 SEO）
function applyRouteSeo(to) {
  const title = to.meta?.title || DEFAULT_TITLE
  const description = to.meta?.description || DEFAULT_DESCRIPTION
  document.title = title

  let metaEl = document.querySelector('meta[name="description"]')
  if (!metaEl) {
    metaEl = document.createElement('meta')
    metaEl.setAttribute('name', 'description')
    document.head.appendChild(metaEl)
  }
  metaEl.setAttribute('content', description)
}

// 增强路由日志
router.beforeEach((to, from, next) => {
  console.log(`路由请求: 从 ${from.path} 导航到 ${to.path}`);
  console.log('目标路由对象:', to);
  // 确保调用next()以完成导航
  next()
})

router.afterEach((to, from) => {
  console.log(`路由完成: 从 ${from.path} 成功导航到 ${to.path}`);
  applyRouteSeo(to)
})

export default router